import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import BlockSteam from "./BlockSteam.vue";
import { uiMapper } from "@/services/store/modules/ui/store";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint"]),
    },
});
const DataMappers = Vue.extend({});
let TitleContentIntro = class TitleContentIntro extends Mixins(UiMappers, DataMappers) {
    get isXs() {
        return this.breakpoint === "xs";
    }
};
TitleContentIntro = __decorate([
    Component({
        components: {
            BlockSteam,
        },
    })
], TitleContentIntro);
export default TitleContentIntro;
